export default __webpack_public_path__ + "static/media/img9.2e63cad1.PNG";